import React from "react";
import { Box, Typography, Chip } from "@material-ui/core";
import { useStyles } from './CompactMessageCardStyles';

const CompactMessageCard = ({ message, index = 0, allColumnNames = [] }) => {
  const classes = useStyles();

  const getValueForColumn = (columnName) => {
    // Only exclude header fields: Timestamp, Batch Number, Message Type
    // Include Procedure Number and all other fields in content
    const excludeFields = ["Timestamp", "Batch Number", "Message Type"];
    if (excludeFields.includes(columnName)) return "";
    
    // Map column display names to camelCase field names
    const columnToFieldMap = {
      "Procedure Number": "procedureNumber",
      "Outlet Number": "outletNumber",
      "CMO Material Description": "cmoMaterialDescription",
      "CMO Material Code": "cmoMaterialCode",
      "Sponsor Material Code": "sponsorMaterialCode",
      "CMO Material Batch Number": "cmoMaterialBatchNumber",
      "Target Quantity": "targetQuantity",
      "Actual Quantity": "actualQuantity",
      "Parameter": "parameter",
      "Set Point": "setPoint",
      "Range": "range",
      "Actual Value": "actualValue",
      "UOM": "uom",
      "Method Number": "methodNumber",
      "Method Name": "methodName",
      "Date Of Sampling": "dateOfSampling",
      "Sample ID": "sampleID",
      "Sample Description": "sampleDescription",
      "Specification Limit": "specificationLimit",
      "Result Value": "resultValue",
      "Result (Pass/Fail)": "resultPassFail",
      "Deviation Title": "deviationTitle",
      "Date Of Deviation": "dateOfDeviation",
      "Assigned To (Role)": "assignedToRole",
      "Assigned To (User)": "assignedToUser",
      "Require Sponsor Review (SME)": "requireSponsorReviewSME",
      "Require Sponsor Review (QA)": "requireSponsorReviewQA",
      "Investigation Number": "investigationNumber",
      "Deviation Status": "deviationStatus",
    };
    
    const fieldName = columnToFieldMap[columnName];
    if (fieldName && message[fieldName] !== undefined) {
      return message[fieldName] || "";
    }
    
    return "";
  };

  // Use allColumnNames for consistent ordering to ensure vertical alignment across all cards
  // This ensures all cards have the same column structure, just like table view
  const columnsToDisplay = allColumnNames && allColumnNames.length > 0 
    ? allColumnNames 
    : [];

  return (
    <Box 
      className={classes.messageCard}
    >
      <Box className={classes.messageHeader}>
        <Box className={classes.headerLeft}>
          <Typography className={classes.timestamp}>
            {message.timestamp || "N/A"}
          </Typography>
          <Box className={classes.batchInfo}>
            <Typography className={classes.batchNumber}>
              {message.batchNumber || "N/A"}
            </Typography>
            {message.messageType && (
              <Chip
                label={message.messageType}
                className={classes.messageTypeChip}
                size="small"
              />
            )}
          </Box>
        </Box>
      </Box>
      {columnsToDisplay.length > 0 && (
        <Box className={classes.messageContent}>
          {columnsToDisplay.map((columnName, idx) => {
            const value = getValueForColumn(columnName);
            if (!value) return null;
            return (
              <Box key={idx} className={classes.contentItem}>
                <Typography className={classes.contentLabel} component="div">
                  {columnName}
                </Typography>
                <Typography className={classes.contentValue} component="div">
                  {value}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default CompactMessageCard;

